<template>
   <el-button
      v-for="(button, key) in data"
      :key="key"
      :size="'medium'"
      :plain="button.plain"
      :circle="button.circle"
      :loading="loading ? loading : button.loading"
      :disabled="button.disabled"
      :type="button.type"
      :icon="button.icon"
      :style="button.style"
      @click="button.event && $emit(button.event, button)"
      >{{ button.name }}</el-button
   >
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

interface Data {
   name: string;
   plain?: boolean;
   round?: boolean;
   circle?: boolean;
   loading?: boolean;
   disabled?: boolean;
   type?: string;
   icon?: string;
   style?: any;
}

export default defineComponent({
   props: {
      /**
       * @param {Array} data 按钮组信息
       */
      data: {
         type: Array as PropType<Data[]>,
         default: (): Data[] => [],
      },

      /**
       * @param {String} loading 加载状态
       */
      loading: {
         type: Boolean,
         default: false,
      },
   },
});
</script>

<style lang='less' scoped>
.sz-button-group {
   width: 100%;
   display: flex;
}
</style>